// extracted by mini-css-extract-plugin
module.exports = {"bb-activism-resources":"bb-activism-resources__ZwtuX","bb-activism-resources__items-list":"bb-activism-resources__items-list__Hebc2"};